export default "__VITE_ASSET__NVDIgXtk__"